import React from "react";

import PropTypes from "prop-types";

const BaseResetHack = ({ children, extraContainerClass }) => (
  <React.Fragment>
    <style
      dangerouslySetInnerHTML={{
        __html: `
      .base-reset-hack input, select, textarea {
        min-height: inherit;
      }
      .relativePosition {
        position: relative;
      }
    `,
      }}
    ></style>
    <div className={`base-reset-hack ${extraContainerClass}`}>{children}</div>
  </React.Fragment>
);

BaseResetHack.propTypes = {
  children: PropTypes.node.isRequired,
  extraContainerClass: PropTypes.string,
};

export default BaseResetHack;
